import { Option } from '@/components/inputs/AutocompleteInput';
import { useMemo } from 'react';
import {
  useGetBatchTransitionsQuery,
  useGetTransitionIncludedStatusesQuery,
} from '../../services/batchCheckpoints.endpoints';
import type { BatchTransition } from '../../models';

type UseBatchTransitionsQueryHook = () => {
  data?: BatchTransition[];
  isLoading: boolean;
};

export const useBatchTransitions = (
  selectedTransitionId?: string,
  useTransitionsQuery: UseBatchTransitionsQueryHook = useGetBatchTransitionsQuery
) => {
  const { data: transitionsData, isLoading: isTransitionsLoading } =
    useTransitionsQuery();

  const transitionOptions: Option[] = useMemo(
    () =>
      (transitionsData ?? []).map((transition) => ({
        label: transition.name,
        data: transition.id,
      })),
    [transitionsData]
  );

  const selectedTransitionMeta = useMemo(
    () => transitionsData?.find((transition) => transition.id === selectedTransitionId),
    [transitionsData, selectedTransitionId]
  );

  const { data: includedStatuses, isLoading: isLoadingStatuses } =
    useGetTransitionIncludedStatusesQuery(selectedTransitionId!, {
      skip: !selectedTransitionId,
    });

  return {
    transitionOptions,
    isTransitionsLoading,
    logisticOperatorId: selectedTransitionMeta?.logisticOperatorId ?? null,
    includedStatuses: includedStatuses ?? [],
    isLoadingStatuses,
  };
};
